import Model from './model.js'
import Contact from './contact.js'
import Deal from './deal.js'

export default class Email extends Model {
	static _routeKey = 'email'

	static _attributes = {
		sent_to_email_address: null,
		body: '',
		subject: '',
		attachments: [],
	}

	tail = {
		sent_to_email_address: () => ['To', this.sent_to_email_address],
		body: () => ['Message', this.body],
		belongs_id: () => ['Associated deal', parseInt(this.belongs_type) != 102 ? this.belongs_id : 'No deal associated'],
		createdDescription: () => this.body,
		mailgun_status: () => ['Status', this.mailgun_status],
	}

	_tailIgnore = [
		'_tailIgnore',
		'tailIgnore',
		'tail',
		'vue',
		'created_at',
		'updated_at',
		'id',
		'belongs_type',
		'$help',
		'$log',
		'user_id',
		'publishedStates',
		'attachments_ids',
		// 'mailgun_status',
		'mailgun_status_at',
	]

	publishedStates = ['draft', 'sent']

	_logIcon() {
		return 'IconEmailDraftCircle'
	}

	timeline(user) {
		let t = this._timeline(user)
		let l = this.level('deal')

		let options = this.published_at == null ? {
			Edit: () => this.edit(),
			Delete: () => this.destroy()
		} : {}

		if (this.created_by_user_id == -1) {
			options = {
				Reply: () => {
					this.vue.$event.$emit('modal-open', {
						view: 'Email',
						modelId: this.belongs_id,
						modelType: this.belongs_type,
						options: {
							replyId: this.mailgun_id,
							subject: this.subject,
							sent_to_email_address: this.sent_from_email_address,
						},
					})
				},
			}
		}
		
		console.log(this)
		let title, contactLine, userLine, status, draftTitle = 'emailed';
		status = this.status()

		if (this.published_at == null) {
			draftTitle = 'created a draft email to'
		}

		if (this.belongs_type == 2 || this.belongs_type == 3) {
			title = this.entry.from + ' '+draftTitle+' ' + this.to?.first_name;
			contactLine = this.sent_to_email_address
			userLine = this.sent_from_email_address
		} else {
			contact = new Contact(t.contact)
			title = this.published_at == null ? t.user + ' created a draft' : t.user + ' emailed ' + contact.fullName()

			if (this.created_by_user_id == -1) {
				title = 'You received an email from ' + contact.fullName()
			}

			contactLine = contact.fullName() + ' ' + this.sent_to_email_address
			userLine = user.fullName() + ' ' + this.sent_from_email_address
		}

		return {
			title: title,
			description: this.subject,
			created_at: this.created_at,
			// icon: this.published_at == null ? 'IconEmailDraftCircle' : 'IconEmailCircle',
			icon: status[1],
			breakdown: {
				'Sent to': this.created_by_user_id != -1 ? contactLine : userLine,
				Subject: this.subject,
				'Message body': this.body,
				'Sent by': this.created_by_user_id != -1 ? userLine : contactLine,
				attachments: this.attachments.length > 0 ? { type: 'Upload', uploads: this.attachments } : 'No attachments',
				// 'Status': this.mailgun_status,
				'Linked deal': l == false ? null : { type: 'NuxtLink', to: l.link, text: l.title, },
				// 'Status': status[2],
			},
			options: options,
		}
	}

	edit() {
		this.vue.$event.$emit('modal-open', {
			view: 'Email',
			editingModel: this,
			options: {
				email: this,
			},
		})
	}

	level(only = null) {
		if (this.belongs_type !== undefined && this.belongs != null) {
			let title = ''
			let link = ''
			let data = null

			switch (true) {
				case this.vue.$help.idName(this.belongs_type) == 'deal':
					link = '/deal/' + this.belongs_id

					data = new Deal(this.belongs)

					title = data.getName()
					break

				case this.vue.$help.idName(this.belongs_type) == 'contact' && only == null:
					data = new Contact(this.belongs)

					title = data.fullName()

					link = '/contact/' + this.belongs_id
					break
				default:
					return false
			}

			return {
				model: this.vue.$help.idName(this.belongs_type),
				data: data,
				title: title,
				link: link,
			}
		}

		return false
	}

	status() {
		let inbound = this.created_by_user_id == -1

		switch (true) {             
			case inbound:
				return ['received email', 'IconEmailDelivered', 'Received']
			case !inbound && this.mailgun_status == 'accepted':
				return ['sent email', 'IconEmailSentAccepted', 'Accepted']
			case !inbound && this.mailgun_status == 'delivered':
				return ['sent email', 'IconEmailDelivered', 'Delivered']
			case !inbound && this.mailgun_status == 'permanent_fail':
				return ['sent email', 'IconEmailSentRejected', 'Permanent fail']
			case !inbound && this.mailgun_status == 'temporary_fail':
				return ['sent email', 'IconEmailSentTemporaryFail', 'Temporary fail']
			case !inbound && this.mailgun_status == 'opened':
				return ['sent email', 'IconEmailSentOpened', 'Opened']
			case !inbound && this.mailgun_status == 'unsubscribed':
				return ['sent email', 'IconEmailSentOpened', 'Unsubscribed']
			case !inbound && this.mailgun_status == 'complained':
				return ['sent email', 'IconEmailSentComplained', 'Complained']
			case !inbound && this.mailgun_status == null && this.published_at != null:
				return ['sent email', 'IconEmailSending', 'Sending']
			case !inbound && this.mailgun_status == null && this.published_at == null:
				return ['draft email', 'IconEmailDraftCircle', 'Unset']
			default:
				return ['sent email', 'IconEmailUnknown', 'Unknown status']
		}
	}

	destroy(emit = 'timeline-deleted') {
		this.vue.$event.$emit('modal-open', {
			view: 'Confirm',
			options: {
				action: '/email/' + this.id,
				message: 'Are you sure you want to delete this draft email?',
				button: 'Delete',
				method: 'DELETE',
				head: 'Delete draft email',
			},
		})
	}
}
